var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#linkedIn)"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 0C6.7 0 0 6.7 0 15C0 23.3 6.7 30 15 30C23.3 30 30 23.3 30 15C30 6.7 23.3 0 15 0ZM12 21H9.5V12H12V21ZM11 11C10.2 11 9.5 10.3 9.5 9.5C9.5 8.7 10.2 8 11 8C11.8 8 12.5 8.7 12.5 9.5C12.5 10.4 11.9 11 11 11ZM21.5 21H19V15C19 15 18.8 14 17.5 14C16.2 14 16 15 16 15V21H13.5V12H16V13C16 13 16.6 11.5 18.5 11.5C20.7 11.5 21.5 13.1 21.5 14.5V21Z","fill":"#323232"})));
}

Linkedin.defaultProps = {"className":"icon-social-svg","width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
